import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Restangular, RestangularModule } from "ngx-restangular";
import { TosterMessageService } from "./toster-message.service";

import {API_URL } from '../config';

@Injectable()
export class DmsAccessService {
  constructor(
    private restangular: Restangular,
    private http: HttpClient,
    private tosterMessageService: TosterMessageService
  ) {}

  public getAlldmsAccessTable() {
    return this.restangular.all("getAlldmsAccessTable");
  }

  public DMSaccessCRUD(id) {
    return this.restangular.one("dms_accesses/" + id);
  }

  public getDmsAccessFormData() {
    return this.restangular.one("getSeverityAccessFormData");
  }

  public getTypeheadEmployees() {
    return this.restangular.one("getEmployeeDropDown");
  }

  public createDMSAccess() {
    return this.restangular.all("dms_accesses");
  }

  public getalldmsfiles() {
    return this.restangular.one("dms_file_uploads");
  }

  public getDmsfile() {
    return this.restangular.one("getDmsFile");
  }

  public getAllDmsFolders() {
    return this.restangular.one("dmsFileFolders");
  }

  public generateDMSfolder() {
    return this.restangular.all("dms_file_uploads");
  }

  public createDMSRevisionFiles() {
    return this.restangular.all("create_dms_revision_file");
  }

  public createDMSFiles() {
    return this.restangular.all("createDmsFiles");
  }

  public updateDMSRevisionFile(id) {
    return this.restangular.all("update_dms_revision_file/" + id);
  }

  public getalldmsRevisionfiles() {
    return this.restangular.one("attachment_revisions");
  }

  public dmsSoftDelete() {
    return this.restangular.one("dmsSoftDelete");
  }

  public getDMSaccess() {
    return this.restangular.one("getDMSaccess");
  }

  public getVideoTemporaryUrl() {
    return this.restangular.one("getVideoTemporaryUrl");
  }

  public getRevisionVideoTemporaryUrl() {
    return this.restangular.one("get_revision_video_temporary_url");
  }

  public DMSApproval() {
    return this.restangular.all("dms_approval_masters");
  }

  public updateDMSApproval(id) {
    return this.restangular.one("dms_approval_masters/" + id);
  }

  public getDmsApprovalTable() {
    return this.restangular.all("get_dms_approval_masters");
  }

  public getDmsUserApprovalTable() {
    return this.restangular.all("get_user_dms_approvals");
  }

  public getDmsApprovalMaster() {
    return this.restangular.one("get_dms_approval_master");
  }

  public getActiveDmsApprovals() {
    return this.restangular.one("get_active_dms_approvals");
  }

  public getActiveDmsDesignation() {
    return this.restangular.one("getActiveDmsDesignation");
  }

  public getDmsApprovallevel(id) {
    return this.restangular.one("dms_approval_levels/" + id);
  }

  public getADmsRevisionApprovals() {
    return this.restangular.one("get_dms_revision_approvals");
  }

  public createDMSApprovalEmployees() {
    return this.restangular.all("dms_approval_employees");
  }

  public approveDMSRevisionFile() {
    return this.restangular.all("approve_dms_revision_file");
  }

  public rejectDMSRevisionFile() {
    return this.restangular.all("reject_dms_revision_file");
  }

  public updateDMSApprovalEmployee(id) {
    return this.restangular.one("dms_approval_employees/" + id);
  }

  public asignDMSFileEmployees() {
    return this.restangular.all("dms_file_accesses");
  }

  public getDmsAsignedEmployeesTable() {
    return this.restangular.all("get_dms_file_assigned_employees");
  }

  public updateDMSAsignedEmployee(id) {
    return this.restangular.one("dms_file_accesses/" + id);
  }

  public createChangeRequest() {
    return this.restangular.all("dms_file_change_requests");
  }

  public getDmsFileChangeRequestsTable() {
    return this.restangular.all("get_dms_file_change_requests");
  }

  public updateDMSFileChangeRequest(id) {
    return this.restangular.one("dms_file_change_requests/" + id);
  }

  public downloadFile(data, type, fileName) {
    const blob = new Blob([data], { type: data.type });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      const url = window.URL.createObjectURL(blob);
      const a: any = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      /*  window.open(url, "_blank");*/
      a.remove();
    }
  }

  public downloadFileIvms(data, type, fileName) {
    const blob = new Blob([data], { type: type });
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, fileName);
    } else {
      const url = window.URL.createObjectURL(blob);
      const a: any = document.createElement("a");
      document.body.appendChild(a);
      a.style = "display: none";
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      /*  window.open(url, "_blank");*/
      a.remove();
    }
  }

  public downloadDocument(id, name) {
    const headersConfig = this.createAuthHeader();
    const filename: string = "https://qhsebe.ilooops.com/api/v1/downloadDMSFile?id=" + id;
    return this.http
      .get(filename, {
        headers: headersConfig,
        responseType: "blob" as "json",
      })
      .map((res) => {
        return {
          data: res,
        };
      })
      .subscribe(
        (res) => {
          if (res) {
            if (res.data) {
              this.downloadFile(res.data, res.data, name);
            }
          }
        },
        (error) => {
          let message = "";
          /* if (error.status == 500) {
           message = error.data.message;
         } else {*/
          message = "Unable to download the attachment";
          //}
          this.tosterMessageService.showError("Error", message);
        },
        () => {}
      );
  }

  public createAuthHeader() {
    const bearerToken = localStorage.getItem("access_token");
    const headerJson = {
      //'Content-Type': 'application/json',
      //'Accept': 'application/json',
      Authorization: `Bearer ${bearerToken}`,
    };
    const headersConfig = new HttpHeaders(headerJson);

    return headersConfig;
  }

  public getAllcommonFiles() {
    return this.restangular.one("getAllcommonFiles");
  }

  public getAllcommonFilesWeb() {
    return this.restangular.one("getAllcommonFilesWeb");
  }


  public getAllcommonFilesWebTraining() {
    return this.restangular.one("getAllcommonFilesWebTraining");
  }


  public getAllcommonFilesWebPreviewAI() {
    return this.restangular.one("getAllcommonFilesWebPreviewAI");
  }



  public deleteCommonFiles() {
    return this.restangular.one("deleteCommonFiles");
  }



  public addcomment() {
    return this.restangular.one("addcomment");
  }

  public showonreport() {
    return this.restangular.one("showonreport");
  }


  public deleteDmsRevsionFile() {
    return this.restangular.one("delete_revision_file");
  }

  public deleteS3File() {
    return this.restangular.one("delete_s3_file");
  }

  public downloadFile2(data, type, fileName) {
    if (data.type === "text/csv") {
      const blob = new Blob(["\ufeff", data], { type: data.type });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const url = window.URL.createObjectURL(blob);
        const a: any = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      }
    }
    else if(data.type === "application/pdf" || data.type === "application/x-pdf" ){
      const blob = new Blob([data], { type: data.type });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const url = window.URL.createObjectURL(blob);
        window.open(url);
       // //console.log(url);
      //  const a: any = document.createElement("a");
      //  document.body.appendChild(a);
      //  a.style = "display: none";
      //  a.href = url;
     //   a.download = fileName;
      //  a.click();
      //  window.URL.revokeObjectURL(url);
      //  a.remove();
      };

    }
    
    
    else {
      const blob = new Blob([data], { type: data.type });
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(blob, fileName);
      } else {
        const url = window.URL.createObjectURL(blob);
        //console.log(url);
        const a: any = document.createElement("a");
        document.body.appendChild(a);
        a.style = "display: none";
        a.href = url;
        a.download = fileName;
        a.click();
        window.URL.revokeObjectURL(url);
        a.remove();
      }
    }
  }

  public downloadDocument2(id, name) {
    const headersConfig = this.createAuthHeader();
    // const filename: string = "https://qhsebe.ilooops.com/api/v1/downloadDMSFile?id=" + id;
    const filename: string = API_URL+"/api/v1/downloadDMSFile?id=" + id;
    return this.http
      .get(filename, {
        headers: headersConfig,
        responseType: "blob" as "json",
      })
      .map((res) => {
        return {
          data: res,
        };
      })
      .subscribe(
        (res) => {
          if (res) {
            if (res.data) {
              //console.log('#####')
              //console.log(res.data);
              this.downloadFile2(res.data, res.data, name);
            }
          }
        },
        (error) => {
          /**/
        },
        () => {
          /**/
        }
      );
  }

  public downloadRevisionFile(id, name) {
    const headersConfig = this.createAuthHeader();
    // const filename: string = "api/v1/download_dms_revision_file?id=" + id;
    const filename: string = API_URL+'/api/v1/download_dms_revision_file?id='+ id;
    return this.http
      .get(filename, {
        headers: headersConfig,
        responseType: "blob" as "json",
      })
      .map((res) => {
        return {
          data: res,
        };
      })
      .subscribe(
        (res) => {
          if (res) {
            if (res.data) {
              console
              this.downloadFile2(res.data, res.data, name);
            }
          }
        },
        (error) => {
          /**/
        },
        () => {
          /**/
        }
      );
  }

  public getalldmsfolders() {
    return this.restangular.all("getalldmsfolders");
  }

  public moveDocument() {
    return this.restangular.all("moveDocument");
  }

  public getEmployeesForDms() {
    return this.restangular.all("getEmployeesForDms");
  }

  public getDmsEmployeeFormData() {
    return this.restangular.one("getDmsEmployeeFormData");
  }

  public sendDmsEmail() {
    return this.restangular.all("sendDmsEmail");
  }



  public updateAttathmentStatus(id) {
    return this.restangular.one("updateAttathmentStatus/" + id);
  }

  public getAllcommonFilesWebDocumentExplorer() {
    return this.restangular.one("getAllcommonFilesWebDocumentExplorer");
  }


}



// WEBPACK FOOTER //
// /app/src/app/services/dms-access.service.ts